import { render, staticRenderFns } from "./UpServiceForm.vue?vue&type=template&id=71650ed2&scoped=true"
import script from "./UpServiceForm.vue?vue&type=script&lang=js"
export * from "./UpServiceForm.vue?vue&type=script&lang=js"
import style0 from "./UpServiceForm.vue?vue&type=style&index=0&id=71650ed2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71650ed2",
  null
  
)

export default component.exports